import React, { useState } from "react";
import useGetRfids from "../hooks/useGetRfids";
import AddRfidModal from "../components/Rfid/AddRfidModal";
import UpdateRfidModal from "../components/Rfid/UpdateRfidModal";
import RfidTable from "../components/Rfid/RfidTable";
import { isTetra } from "../utils/access";

export default function Rfid() {
  const { rfids, isLoading, error, refetch } = useGetRfids();

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRfid, setSelectedRfid] = useState(null);

  const handleEdit = (rfid) => {
    setSelectedRfid(rfid);
    setShowEditModal(true);
  };

  const handleCloseEdit = () => {
    setShowEditModal(false);
    setSelectedRfid(null);
  };

  return (
    <div className="min-h-screen bg-neutral-50 p-6">
      <div className="max-w-6xl mx-auto">
        <header className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-semibold tracking-tight text-ink">
            RFID Management
          </h1>

          {isTetra() && (
            <button
              onClick={() => setShowAddModal(true)}
              className="px-6 py-2.5 bg-neutral-900 text-white text-sm rounded hover:bg-neutral-800 transition"
            >
              + ADD RFID
            </button>
          )}
        </header>

        <RfidTable
          rfids={rfids}
          isLoading={isLoading}
          error={error}
          onEdit={isTetra() ? handleEdit : undefined}
        />
      </div>

      <AddRfidModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={refetch}
      />

      <UpdateRfidModal
        isOpen={showEditModal}
        rfid={selectedRfid}
        onClose={handleCloseEdit}
        onSuccess={refetch}
      />
    </div>
  );
}